<template>
	<div class="topmenu">
		<div class="topd" v-if="topdpngshow"></div>
		<div class="container">
			<div class="top" style="position: relative;">
				<a href="javascript:;" class="logo">
					<img src="@/assets/img/top.png" alt="">
					<div class="phone">
						<p>全国残疾人服务热线</p>
						<div class="tu">
							<img src="@/assets/img/phone.png" alt="">
							<span>12385</span>
						</div>
					</div>

				</a>

			</div>
			<div class="menubox">
				<ul class="menulist">
					<li v-for="(item, i) in menu" :key="item.id">
						<router-link :to="{name:'Index'}" active-class="active" v-if="item.type=='0'">{{item.text}}
						</router-link>
						<router-link :to="{name:'List',query:{menuid:item.id,text:item.text}}" active-class="active"
							v-if="item.type=='1'">{{item.text}}</router-link>
						<router-link :to="{name:'Column',query:{menuid:item.id,text:item.text}}" active-class="active"
							v-if="item.type=='2'">{{item.text}}</router-link>

					</li>
				</ul>

			</div>
			<div class="gongju">
				<span class="time">
					<span class="welcome">欢迎浏览本网站 您是本站第<b>{{fkscount}}</b>位访客</span>
					<span>{{nowDate}}</span>
					<span>{{nowWeek}}</span>
					<span>{{nowTime}}</span>
				</span>
				<span class="searchbox">
					<input type="text" class="searchtext" v-model="keyword" />
					<a href="javascript:;" class="searchbtn" @click="gosearch">搜索</a>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {

		name: 'topmenu',
		components: {},
		data() {
			return {
				topdpngshow: false,
				keyword: '',
				fkscount: '',
				timer: null,
				nowWeek: '',
				nowDate: '',
				nowTime: '',
				menu: [{
						id: '0',
						text: '首页',
						type: '0'
					},
					{
						id: '1',
						text: '新闻动态',
						type: '1'
					},
					{
						id: '2',
						text: '组织建设',
						type: '1'
					},
					{
						id: '5',
						text: '政策法规',
						type: '1'
					},
					{
						id: '16',
						text: '社会保障',
						type: '2'
					},
					{
						id: '41',
						text: '维权信访',
						type: '2'
					}, {
						id: '15',
						text: '扶残助残',
						type: '1'
					}, {
						id: '14',
						text: '辅助器具',
						type: '1'
					}, {
						id: '45',
						text: '文献资料',
						type: '1'
					}, {
						id: '12',
						text: '平安建设',
						type: '1'
					}, {
						id: '10',
						text: '党风廉政',
						type: '1'
					}, {
						id: '11',
						text: '党建',
						type: '1'
					}, {
						id: '13',
						text: '心理服务',
						type: '1'
					}
				]
			};
		},
		mounted() {
			this.timer = setInterval(() => {
				this.setNowTimes()
			}, 1000)
			this.findFangkejilushu()
		},
		methods: {
			setNowTimes() {
				let myDate = new Date()
				// console.log(myDate)
				let wk = myDate.getDay()
				let yy = String(myDate.getFullYear())
				let mm = myDate.getMonth() + 1
				let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
				let hou = String(myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours())
				let min = String(myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes())
				let sec = String(myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds())
				let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
				let week = weeks[wk]
				this.nowDate = yy + '-' + mm + '-' + dd
				this.nowTime = hou + ':' + min + ':' + sec
				this.nowWeek = week
			},
			gosearch() {
				console.log('展示')
				var keyword = this.keyword
				this.$router.push({
					path: '/List',
					query: {
						keyword: keyword,
					}
				})

			},
			findFangkejilushu() {
				var that = this;
				that.$myHttp.post("findFangkejilushu")
					.then(function(data) {
						console.log(data)
						if (data.status == "200") {
							that.fkscount = data.data.fkscount;
						} else {
							alert("数据请求错误")
						}

					}).catch(function(error) {
						alert(error)
					})
			}

		}
	};
</script>

<style scoped>
	.menulist {
		height: 40px;
		width: 100%;
		background: #199352;

	}

	.menulist li {
		display: inline-block;
		height: 40px;

	}

	.menulist li a {
		height: 40px;
		line-height: 40px;
		padding: 0 6px;
		display: inline-block;
		color: #fff;
		font-size: 17px;
		font-weight: bold;
		transition: all .2s ease-in-out;
	}

	.menulist li a:hover,
	.menulist li .router-link-active {
		background: #4c840c;
	}

	.gongju {
		width: 100%;
		height: 36px;
		display: inline-block;
		justify-content: space-between;
		flex-direction: row;
		align-items: center;
		line-height: 36px;
	}

	.gongju .time {
		float: left;
	}

	.welcome {
		padding-right: 50px;
	}

	.welcome b {
		color: red;
	}

	.searchbox {
		float: right;
		height: 36px;
		direction: flex;
		align-items: center;
	}

	.searchbox .searchtext {
		height: 20px;
		padding: 2px 5px;
		line-height: 20px;
		border-radius: 2px;
		border: 1px solid #dac3b0;
		width: 140px;
	}

	.searchbox .searchbtn {
		height: 20px;
		line-height: 20px;
		padding: 0 5px;
		border-radius: 2px;
		border: 1px solid #dac3b0;
		display: inline-block;
		color: #444;
		font-size: 12px;
		position: relative;
		top: 1px;
	}

	.topd {
		background: url(../../../assets/img/topd.png) repeat-x top center;
		background-size: auto 330px;
		height: 426px;
	}

	.top .phone {
		width: 220px;
		position: absolute;
		top: 30px;
		right: 0;
	}

	.top .phone p {
		font-size: 24px;
		font-weight: bold;
		color: #199352;
	}

	.top .phone .tu {
		display: flex;
		align-items: center;
		margin-top: 6px;
	}

	.top .phone .tu img {
		width: 50px;
		margin-left: 40px
	}
	.top .phone .tu span{
		font-size: 24px;
		    font-weight: bold;
		    color: #199352;
			margin-left: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/views/front/components/topmenu.vue